import { createSlice } from "@reduxjs/toolkit";
import { getAxios, postAxios } from "./axiosActions";
import _ from 'lodash';
import Cookies from 'js-cookie'


export const initialState = {
    loading: false,
    hasErrors: false,
    loginDetails: null,
    validOtp: false,
    otpResponse: 0,
    isvalidToken : false
};

const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        apiHit: state => {
            state.loading = true;
        },
        getloginSuccess: (state, { payload }) => {  
            state.loginDetails = payload;
            if (typeof payload!="number") {
                Cookies.set('userId', payload?.id, { expires: new Date(payload?.tokenExpiry) });
            }
            
            state.loading = false;
            state.hasErrors = false;
        },
        validateOTPSuccess: (state, { payload }) => {
            const validOtp = payload == 1 ? true : false;
            state.validOtp = validOtp;
            if (validOtp) {
                Cookies.set('customAuthToken', state.loginDetails.token, { expires: new Date(state.loginDetails.tokenExpiry) });
                Cookies.set('userId', state.loginDetails?.id, { expires: new Date(state.loginDetails?.tokenExpiry) });
            }
            state.otpResponse = payload;
            state.loading = false;
            state.hasErrors = false;
        },
        authenticateTokenuccess: (state, { payload }) => {
            state.isvalidToken = payload;
            state.loading = false;
            state.hasErrors = false;
        },
        apiCallFailure: state => {
            state.loading = false;
            state.hasErrors = true;
        },


    },
});

export const { apiHit, getloginSuccess, apiCallFailure, validateOTPSuccess,authenticateTokenuccess } = loginSlice.actions;

export const loginSelector = state => state.login;
export default loginSlice.reducer;


export const createSignup = (data) => {
    return async dispatch => {
        dispatch(apiHit());
        try {
            const response = await postAxios('api/CustomAuth/RegisterUser', { params: data });
            dispatch(getloginSuccess(response));
        } catch (error) {
            dispatch(apiCallFailure());
        }
    }
};


export const ValidateOTP = (id, otp) => {
    return async dispatch => {
        dispatch(apiHit());
        try {
            const response = await getAxios('api/CustomAuth/Authenticate?id=' + id + '&otp=' + otp,
                { params: {} });
            dispatch(validateOTPSuccess(response));
        } catch (error) {
            dispatch(apiCallFailure());
        }
    }
};

export const authenticateToken = (token) => {
    return async dispatch => {
        dispatch(apiHit());
        try {
            const response = await getAxios('api/CustomAuth/AuthenticateToken?token='+token, { params: {} });
            dispatch(authenticateTokenuccess(response));
        } catch (error) {
            dispatch(apiCallFailure());
        }
    }
};

export const updateSuccessfulLogin = (userId) => {
    return async dispatch => {
        dispatch(apiHit());
        try {
            const response = await getAxios('api/CustomAuth/UpdateSuccessfulLogin?userId='+userId, { params: {} });
           // dispatch(authenticateTokenuccess(response));
        } catch (error) {
            dispatch(apiCallFailure());
        }
    }
};

